import B2CConfig from './B2CConfig'
import { PublicClientApplication } from '@azure/msal-browser'

export default new PublicClientApplication(B2CConfig.msalConfig)